import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import DashboardLayout from "../../../examples/LayoutContainers/DashboardLayout";
import { ShimmerPostList } from "react-shimmer-effects";
import { deleteMachineTypes, getMachineTypes } from "../../../actions/machine-type/machine-types";
import MachineTypesListComponent from "../../../components/Definition/MachineTypes/MachineTypesListComponent";
import { deleteOrigin } from "../../../actions/origin/origin";

export default function MachineTypeScreen() {
    const [groups, setGroup] = useState({ data: [], links: {} });
    const [loading, setLoading] = useState(true);
    const [status, setStatusDelete] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();

    useEffect(() => {
        setLoading(true);
        const fetchApi = async () => {
            const params = new URLSearchParams(searchParams);
            try {
                const usersData = await getMachineTypes(params.toString());
                setLoading(false);
                setGroup(usersData.status !== "error" ? usersData.message : { data: [], links: {} });
            } catch (error) {
                toast.error('خطا در اتصال به سرور!');
                setLoading(false);
            }
        };

        fetchApi();
    }, [searchParams,status]);

    return (
        <DashboardLayout>
            {loading ? <ShimmerPostList postStyle="STYLE_THREE" col={1} row={3} gap={30} /> : <MachineTypesListComponent lists={groups} deleteInvoke={async(id)=>{
                const prompt = window.confirm("آیا میخواهید نوع دستگاه حذف شود ؟ با این کار گزارشات وابسته از بین خواهد رفت")
                if(prompt){
                    const response = await deleteMachineTypes(id);
                    if (response.status === "success") {
                        toast.success("نوع دستگاه حذف شد!");
                        setStatusDelete(true);
                    } else {
                        toast.error("خطا در حذف نوع دستگاه");
                    }
                }
            }} />}
        </DashboardLayout>
    );
}
